import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { filter, first } from 'rxjs/operators';
import { LegalDocumentsProvider, LEGAL_DOCUMENT_FACADE_PROVIDER_TOKEN } from '../legal-document-provider';
import { CommonModule } from '@angular/common';
import { LegalDocumentPreviewComponent } from '@app/core/legal-documents/legal-document/legal-document-preview/legal-document-preview.component';

@Component({
  selector: 'app-tos-modal',
  templateUrl: './legal-document.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    LegalDocumentPreviewComponent
  ],
})
export class LegalDocumentComponent implements OnInit {
  protected readonly legalDocument$ = this.legalDocumentsProvider.data$;

  constructor(@Inject(LEGAL_DOCUMENT_FACADE_PROVIDER_TOKEN) private legalDocumentsProvider: LegalDocumentsProvider) {}

  public ngOnInit(): void {
    this.legalDocumentsProvider.loadData();

    this.legalDocument$.pipe(
      filter(legalDocument => !!legalDocument),
      first(),
    ).subscribe(legalDocument => {
      if (legalDocument.url) {
        window.location.href = legalDocument.url;
      }
    });
  }
}
